import createIcon from '../../createIcon';

/**
 * @component @name Crib
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggOEgxMlYzSDhDNS43OSAzIDQgNC43OSA0IDdWMTNDNCAxNC4xIDQuOSAxNSA2IDE1SDhWMTcuOTNDNy4zOSAxNy41OCA2Ljg0IDE3LjE1IDYuMzUgMTYuNjZMNC45MyAxOC4wOEM2Ljc0IDE5Ljg4IDkuMjQgMjEgMTIgMjFDMTQuNzYgMjEgMTcuMjYgMTkuODggMTkuMDcgMTguMDdMMTcuNjUgMTYuNjVDMTcuMTYgMTcuMTQgMTYuNiAxNy41NyAxNiAxNy45MlYxNUgxOEMxOS4xIDE1IDIwIDE0LjEgMjAgMTNWMTBDMjAgOC45IDE5LjEgOCAxOCA4Wk0xNCAxOC43NUMxMy4zNiAxOC45MSAxMi42OSAxOSAxMiAxOUMxMS4zMSAxOSAxMC42NCAxOC45MSAxMCAxOC43NVYxNUgxNFYxOC43NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Crib = createIcon('Crib', [
  [
    'path',
    {
      d: 'M18 8H12V3H8C5.79 3 4 4.79 4 7V13C4 14.1 4.9 15 6 15H8V17.93C7.39 17.58 6.84 17.15 6.35 16.66L4.93 18.08C6.74 19.88 9.24 21 12 21C14.76 21 17.26 19.88 19.07 18.07L17.65 16.65C17.16 17.14 16.6 17.57 16 17.92V15H18C19.1 15 20 14.1 20 13V10C20 8.9 19.1 8 18 8ZM14 18.75C13.36 18.91 12.69 19 12 19C11.31 19 10.64 18.91 10 18.75V15H14V18.75Z',
      key: 'qwa021',
    },
  ],
]);

export default Crib;
